import kibbleWebP from './kibble.webp';
import kibblePng from './kibble.png';
import kibbleJp2 from './kibble.jp2';

export default [kibbleWebP, kibbleJp2, kibblePng];
